import type { AppDeDelivery } from "@nhomi/core";

/* O ícone de cada app de entrega, nos chips de "por qual app".
   Emoji não diz "iFood"; o ícone vermelho diz, num relance. "Do
   restaurante" e "Outro" não têm marca, e ficam só com o nome. Os
   arquivos moram em `public/apps` (e em `nativo/assets/apps`). */
const COM_LOGO = new Set<AppDeDelivery>(["ifood", "99food", "keeta", "rappi", "aiqfome"]);

export function LogoDoApp({ app }: { app: AppDeDelivery }) {
  if (!COM_LOGO.has(app)) return null;
  return <img className="logo-do-app" src={`/apps/${app}.png`} alt="" width={18} height={18} />;
}
